import { styled } from "@mui/material/styles";

const Link = styled("a")(() => ({
  textDecoration: "underline",
  color: "#1976D2",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
}));

export default Link;
